import { ManifestActions } from './actionType';
import {
    addJobToManifest,
    updateManifestExternalReferences,
    archiveManifest,
    createManifest,
    getManifestById,
    unarchiveManifest,
    updateManifest,
} from './client';
import {
    UpdateManifestExternalReferencesPayload,
    AddRemoveJobFromManifestPayload,
    CreateManifestPayload,
    UpdateManifestPayload,
} from './types';

export const doGetManifestById: Function = (manifestId: string) => async (dispatch: Function) => {
    dispatch({
        type: ManifestActions.GET_MANIFEST_BY_ID_REQUEST,
    });

    try {
        const payload = await getManifestById(manifestId);
        dispatch({
            type: ManifestActions.GET_MANIFEST_BY_ID_SUCCESS,
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({
            type: ManifestActions.GET_MANIFEST_BY_ID_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doUpdateManifest: Function =
    (manifestId: string, payload: UpdateManifestPayload) => async (dispatch: Function) => {
        dispatch({
            type: ManifestActions.UPDATE_MANIFEST_REQUEST,
        });

        try {
            const updatedManifest = await updateManifest(manifestId, payload);
            dispatch({
                type: ManifestActions.UPDATE_MANIFEST_SUCCESS,
                payload: updatedManifest,
            });
            return updatedManifest;
        } catch (e: any) {
            dispatch({
                type: ManifestActions.UPDATE_MANIFEST_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };

export const doArchiveManifest: Function = (manifestId: string) => async (dispatch: Function) => {
    dispatch({
        type: ManifestActions.ARCHIVE_MANIFEST_REQUEST,
    });

    try {
        const updatedManifest = await archiveManifest(manifestId);
        dispatch({
            type: ManifestActions.ARCHIVE_MANIFEST_SUCCESS,
            payload: updatedManifest,
        });
        return updatedManifest;
    } catch (e: any) {
        dispatch({
            type: ManifestActions.ARCHIVE_MANIFEST_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doUnarchiveManifest: Function = (manifestId: string) => async (dispatch: Function) => {
    dispatch({
        type: ManifestActions.UNARCHIVE_MANIFEST_REQUEST,
    });

    try {
        const updatedManifest = await unarchiveManifest(manifestId);
        dispatch({
            type: ManifestActions.UNARCHIVE_MANIFEST_SUCCESS,
            payload: updatedManifest,
        });
        return updatedManifest;
    } catch (e: any) {
        dispatch({
            type: ManifestActions.UNARCHIVE_MANIFEST_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doCreateManifest: Function = (payload: CreateManifestPayload) => async (dispatch: Function) => {
    dispatch({
        type: ManifestActions.CREATE_MANIFEST_REQUEST,
    });

    try {
        const createdManifest = await createManifest(payload);
        dispatch({
            type: ManifestActions.CREATE_MANIFEST_SUCCESS,
            payload: createdManifest,
        });
        return createdManifest;
    } catch (e: any) {
        dispatch({
            type: ManifestActions.CREATE_MANIFEST_ERROR,
            error: e?.response?.data,
        });
        throw e;
    }
};

export const doAddJobToManifest: Function =
    (payload: AddRemoveJobFromManifestPayload) => async (dispatch: Function) => {
        dispatch({
            type: ManifestActions.ADD_JOB_TO_MANIFEST_REQUEST,
        });

        try {
            const updatedManifest = await addJobToManifest(payload);
            dispatch({
                type: ManifestActions.ADD_JOB_TO_MANIFEST_SUCCESS,
                payload: updatedManifest,
            });

            return updatedManifest;
        } catch (e: any) {
            dispatch({
                type: ManifestActions.ADD_JOB_TO_MANIFEST_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };

export const doUpdateManifestExternalReferences: Function =
    (manifestId: string, payload: UpdateManifestExternalReferencesPayload) => async (dispatch: Function) => {
        dispatch({
            type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_REQUEST,
        });

        try {
            const updatedManifest = await updateManifestExternalReferences(manifestId, payload);
            dispatch({
                type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_SUCCESS,
                payload: updatedManifest,
            });
            return updatedManifest;
        } catch (e: any) {
            dispatch({
                type: ManifestActions.UPDATE_MANIFEST_EXTERNAL_REFERENCES_ERROR,
                error: e?.response?.data,
            });
            throw e;
        }
    };
